import styled from "@emotion/styled";
import { Button, DropDown } from "@src/components";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_SEARCH_COLUMN = "userInfo.name";

interface PartnerBenefitsFilterProps {
    setFilter: Dispatch<SetStateAction<Record<string, any>>>;
}

const PartnerBenefitsFilter = ({ setFilter }: PartnerBenefitsFilterProps) => {
    const [searchType, setSearchType] = useState<string>(DEFAULT_SEARCH_COLUMN);
    const [searchText, setSearchText] = useState<string>("");
    const location = useLocation();

    useEffect(() => {
        setSearchText("");
    }, [searchType]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const searchColumn = queryParams.get("searchColumn");
        const searchValue = queryParams.get("searchValue");
        if (searchColumn) setSearchType(searchColumn);
        if (searchValue) setSearchText(searchValue);
    }, [location.search]);

    const handleSearch = () => {
        setFilter({
            searchColumn: searchType,
            searchValue: searchText,
        });
    };

    const handleClear = () => {
        setSearchType(DEFAULT_SEARCH_COLUMN);
        setSearchText("");
        setFilter({ searchColumn: "" });
    };

    return (
        <StyledPartnerFilter>
            <StyledFilterBox>
                <div className="itemRow">
                    <span>검색</span>
                    <div className="dropDown">
                        <DropDown
                            border
                            data={[
                                {
                                    id: 1,
                                    key: "userInfo.name",
                                    value: "이름",
                                },
                                {
                                    id: 2,
                                    key: "userPaybackPartner.name",
                                    value: "파트너 닉네임",
                                },
                            ]}
                            defaultValue={searchType}
                            handleChange={(e, text, value) => {
                                value && setSearchType(value);
                            }}
                        />
                    </div>
                    <StyledReasonWrapper>
                        <input
                            type="text"
                            placeholder="이름이나 닉네임을  입력해주세요  "
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setSearchText(e.target.value);
                            }}
                            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                if (e.key === "Enter") {
                                    handleSearch();
                                }
                            }}
                            value={searchText}
                        />
                    </StyledReasonWrapper>
                </div>
            </StyledFilterBox>
            <StyledSearchButton>
                <Button color="gray" handleClick={handleClear} label="전체 해제" size="medium" />
                <Button color="purple" handleClick={handleSearch} label="검색" size="medium" />
            </StyledSearchButton>
        </StyledPartnerFilter>
    );
};

export default PartnerBenefitsFilter;

const StyledPartnerFilter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 23px;
    width: 100%;
    margin-bottom: 32px;
`;

const StyledFilterBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    height: fit-content;
    background-color: #f4f5f7;
    border-radius: 10px;
    padding: 10px 24px 24px 24px;
    margin-top: 20px;
    & > .itemRow {
        display: flex;
        gap: 16px;
        align-items: center;
        box-sizing: border-box;
        & > span {
            width: 63px;
            font-weight: 400;
            font-size: 13px;
            color: #222222;
            letter-spacing: -0.4px;
        }
        & > .dropDown {
            height: 40px;
            & > div {
                height: 100%;
                & > label {
                    & > select {
                        height: 100%;
                    }
                }
            }
        }
    }
`;

const StyledReasonWrapper = styled.div`
    width: 648px;
    height: 40px;
    display: flex;
    gap: 16px;
    align-items: center;
    & > span {
        font-weight: 400;
        font-size: 13px;
        width: 80px;
        .essential {
            color: #f45b5b;
        }
    }
    & > input {
        height: 100%;
        width: calc(100% - 96px);
        padding: 12px;
        font-weight: 400;
        font-size: 14px;
        line-height: 170%;
        color: #283237;
        border: 1px solid #e3e3e6;
        border-radius: 8px;
        outline: none;
    }
`;

const StyledSearchButton = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
    justify-content: flex-end;
`;
